
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";

export async function uploadToStorage(file, pathPrefix = "uploads", fileNameOverride) {
    if (!file) throw new Error("uploadToStorage: 'file' is required");

    const ts = Date.now();
    const originalName = (file).name || "scan.jpg";
    const safeName = (fileNameOverride || originalName).replace(/[^\w.-]/g, "_");

    const path = `${pathPrefix}/${ts}-${safeName}`;
    const storageRef = ref(storage, path);

    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);
    return { url, path };
}